import React from 'react';
import { useParams } from 'react-router-dom';
import { ShopCatalog } from '../components/shop/ShopCatalog';
import { categories } from '../data/categories';
import type { CategoryId } from '../types/product';
import { NotFound } from './NotFound';
export function Shop({
  deals = false
}: {
  deals?: boolean;
}) {
  const {
    category
  } = useParams();
  const valid = categories.find(c => c.id === category)?.id as CategoryId | undefined;
  if (category && !valid) return <NotFound data-id="element-682" data-mp="347j0kathw2j7" />;

  // key resets filters when switching category
  return <ShopCatalog key={`${valid ?? 'all'}-${deals}`} category={valid} deals={deals} data-id="element-683" data-mp="2zcdftfbtwtwp" />;
}